import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { getProductBySlug } from '../data/aiProducts';

const ProductDetailPage = () => {
  const { slug } = useParams();
  const product = getProductBySlug(slug);

  if (!product) {
    return <Navigate to="/products" replace />;
  }

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://monkstack.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Our Products',
        item: 'https://monkstack.com/products',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: product.name,
        item: `https://monkstack.com/products/${product.slug}`,
      },
    ],
  };

  return (
    <div className="App products-page product-detail-page">
      <SEO
        title={product.name}
        description={product.desc}
        url={`https://monkstack.com/products/${product.slug}`}
        image={`https://monkstack.com${product.gif}`}
        structuredData={breadcrumbSchema}
      />
      <Navbar />
      <section className="products-section product-detail-section">
        <div className="container">
          <Link to="/products" className="product-detail-back">
            ← All Products
          </Link>

          <div className="product-detail-content">
            <h1 className="product-detail-title">{product.name}</h1>
            <p className="product-detail-desc">{product.desc}</p>

            {product.externalUrl && (
              <a
                href={product.externalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="product-detail-external-link"
              >
                {product.externalLabel || 'Visit product'}
              </a>
            )}

            <div className="ai-card-media product-detail-media">
              <div className="ai-card-chrome">
                <span className="ai-chrome-dot ai-chrome-dot--r" />
                <span className="ai-chrome-dot ai-chrome-dot--y" />
                <span className="ai-chrome-dot ai-chrome-dot--g" />
              </div>
              <img src={product.gif} alt={product.name} className="ai-card-gif" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ProductDetailPage;
